import type { Locale } from '@tuic/i18n';
import { CacheTag } from '../../utils';
import { remember, serializeDataToCacheKey } from '@tuic/cache';
import { Pcl } from '../../index';
import { logger } from '@tuic/logger';

/**
 * Fetches the ships from the PCL API.
 */
export const getShips = async (locale: Locale): Promise<Pcl.Ship[]> => {
  let { data, error } = await Pcl.getShips({ query: { locale } });

  if (error) {
    logger.error(`Could not fetch Ships. Locale: ${locale}`);
    logger.error(error);

    return [];
  }

  return data ?? [];
};

/**
 * Fetches the ships from the PCL API.
 */
export const cachedGetShips = (locale: Locale): Promise<Pcl.Ship[]> =>
  remember(
    serializeDataToCacheKey([CacheTag.pcl, 'getShips', locale]),
    () => getShips(locale),
    {
      tags: [CacheTag.pcl, CacheTag.shipResource, CacheTag.getShips],
      ttl: 600,
    },
  );
